import React, { useState } from 'react';
import './EngineeringShowcase.css';

const showcaseItems = [
  {
    title: 'IT SOLUTIONS',
    description:
      'Delivering cutting-edge IT services including software development, cloud solutions, and digital transformation to drive business growth.',
    buttonText: 'Learn More',
    image: 'https://images.unsplash.com/photo-1528901166007-3784c7dd3653?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTc1fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D',
  },
  {
    title: 'NON-IT SERVICES',
    description:
      'Providing skilled workforce and business support across diverse non-IT domains such as operations, administration, and facility management.',
    buttonText: 'Explore Services',
    image: 'https://images.unsplash.com/photo-1581090698603-a8a626ffdc14?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTI2fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D',
  },
  {
    title: 'TRAINING & UPSKILLING',
    description:
      'Equipping professionals with modern skills through specialized training programs in technology, management, and workplace readiness.',
    buttonText: 'View Programs',
    image: 'https://images.unsplash.com/photo-1581092568395-d68050c2ab43?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTI4fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D',
  },
  {
    title: 'CAREER OPPORTUNITIES',
    description:
      'Connecting talented individuals with top organizations, offering rewarding job opportunities across IT and Non-IT industries.',
    buttonText: 'See Jobs',
    image: 'https://images.unsplash.com/photo-1581091870598-36ce9bad5c77?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTg2fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D',
  },
];

const EngineeringShowcase = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className="engineering-showcase">
      <h1 className='head'>
        Empowering Careers <span className='heading1'>with Excellence</span>
      </h1>
      <div className="left-image">
        <img
          src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTIzfHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
          alt="Future of Work"
        />
      </div>
      <div className="right-content">
        <h2>{showcaseItems[currentIndex].title}</h2>
        <p>{showcaseItems[currentIndex].description}</p>

        <img
          src={showcaseItems[currentIndex].image}
          alt={showcaseItems[currentIndex].title}
          className="feature-image"
        />

        <div className="navigation-bubbles">
          {showcaseItems.map((_, index) => (
            <span
              key={index}
              className={`bubble ${currentIndex === index ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EngineeringShowcase;
